<template>
  <div class="shop">

    <div class="alert">Pour entrainement seulement.<br>Jusqu'a épuisement du stock</div>
    <p>
      <label>Formulaire de commande NIKE : </label>
      <a class="link" target="_blank" href="https://forms.gle/baM2Wct4bBdTPRCW7">CDE EQUIPEMENTS NIKE (Short / Chaussettes ENTRAINEMENT)</a>
      <br/>
      <v-img src="https://www.asspm.fr/lab/data/apps/asspm/images/chaussettes.png"/>
      <v-img src="https://www.asspm.fr/lab/data/apps/asspm/images/short.png"/>
    </p>

    <div class="alert">Pour MATCHS !</div>
    <p>
      <label>Formulaire de commande KAPPA : </label>
      <a class="link" target="_blank" href="https://forms.gle/WGHLrcuBFhnJa9pe8">CDE EQUIPEMENTS KAPPA (Short / Chaussettes pour MATCHS)</a>
      <br/>
      <v-img src="https://www.asspm.fr/lab/data/apps/asspm/images/chaussettes.png"/>
      <v-img src="https://www.asspm.fr/lab/data/apps/asspm/images/short.png"/>
      <v-img src="https://www.asspm.fr/lab/data/apps/asspm/images/maillot_1.png"/>
    </p>

    <p>
      <label>Pour les Féminines : </label>
      <a class="link" target="_blank" href="https://docs.google.com/forms/d/14ZlwSX9hPHGLmkUW2ATC57sKMdsAaWa9ws9OH5lzNeE/viewform">Cde EQUIPEMENTS GF Montrevault sur Èvre (Short / Chaussettes)</a>
      <br/>
    </p>

    <a target="_blank" :href="item.tarifs_boutique">
      <pdf ref="pdf" :src="item.tarifs_boutique" :resize="true" :text="false">
        <template slot="loading">
        </template>
      </pdf>
    </a>
    
    <a target="_blank" :href="item.tarifs_location_asspm">
      <pdf ref="pdf" :src="item.tarifs_location_asspm" :resize="true" :text="false">
        <template slot="loading">
        </template>
      </pdf>
    </a>
    
  </div>
</template>
<style scoped lang="stylus">
  #app
    p
      text-align center
    a.link
      text-decoration underline
</style>

<script>

  import pdf from 'pdfvuer'
  import MetaService from '../../services/meta.service'

  const META_INFO = {
    title : "La boutique",
    image : "https://www.asspm.fr/lab/data/apps/asspm/files/2020/08/75580410_2467882063301685_1986581640377270272_n.jpg",
    description : "La boutique du club de football de l'Avenir Sport Saint Pierre Montrevault",
  }

  export default {
    name: 'Shop',
    metaInfo() {
      if (!this.sendMetaInfo) return
      return MetaService.info(META_INFO)
    },
    mounted() {
      this.sendMetaInfo = true
    },
    components: {
      pdf
    },
    data() {
      return {
        item: {
          tarifs_location_asspm: "https://www.asspm.fr/rubriques/tarifs_location_asspm.pdf"
          , tarifs_boutique: "https://www.asspm.fr/rubriques/tarifs_boutique.pdf"
        }
      }
    }
  }

</script>

<style scoped lang="stylus">
  .shop
    img
      max-width 170px
    .flyer
      max-width 800px
    .alert
      position absolute
      color #f00
      padding 20px
      max-width 170px
      font-size 20px
      font-weight 700
      text-align center
      margin-top 50px
      margin-left 50px
</style>